<template>
  <div>
    <InfoDetail
      v-if="pageStatus === 'infoDetail'"
      @changeToBusinessLicense="changeToBusinessLicense()"
      @changeToAuthorizationDocument="changeToAuthorizationDocument()"
    >
    </InfoDetail>
    <BusinessLicenseVerify
      v-if="pageStatus === 'businessLicense'"
      @changeToInfoDetail="changeToInfoDetail()"
    ></BusinessLicenseVerify>
    <AuthorizationVerify
      v-if="pageStatus === 'authorizationDocument'"
      @changeToInfoDetail="changeToInfoDetail()"
    ></AuthorizationVerify>
  </div>
</template>
<script>
import InfoDetail from "./infoDetail/InfoDetail";
import BusinessLicenseVerify from "./companyVerify/BusinessLicenseVerify";
import AuthorizationVerify from "./companyVerify/AuthorizationVerify";
export default {
  name: "PersonInfo",
  components: {
    InfoDetail,
    BusinessLicenseVerify,
    AuthorizationVerify,
  },
  data() {
    return {
      tabListNoTitle: [],
      pageStatus: "infoDetail",
    };
  },
  methods: {
    changeToAuthorizationDocument() {
      this.pageStatus = "authorizationDocument";
    },
    changeToBusinessLicense() {
      this.pageStatus = "businessLicense";
    },
    changeToInfoDetail() {
      this.pageStatus = "infoDetail";
    },
  },
};
</script>

<style>
</style>